import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m8.993 20.292-.119.012c-.968.103-1.948.073-2.937.011a1.487 1.487 0 0 1-1.388-1.487V16.63a.45.45 0 0 0-.264-.408l-2.187-.984a.447.447 0 0 1-.162-.691l2.216-2.71a.45.45 0 0 0 .101-.276L4.3 8.59c.056-3.56 2.883-6.478 6.442-6.442q.495.006.98.016m-2.729 18.13c.827-.08 1.522-.077 2.492-.671C12.5 19 12.5 17.1 10.5 17.5c-1.225.245-1.61 1.45-1.507 2.792m0 0c.057.74.262 1.521.556 2.207m8.287-3.5c-.124 1.152.002 1.394.164 3.5"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 4.986 17.5 1.5m-.633 5.681L21.5 5.5m-4.633 5.315H22M16.867 14.5l3.416 2M10 11.939l1.524 1.561L14 9.5"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const PersonalityTestIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
